// src/router/canonicalPaths.ts

// ENG-21797 The SMS short links are already in patients' inboxes and stay live,
// so the SPA serves them and canonicalises to a readable route.
const SHORT_LINK_MAP: { pattern: RegExp; canonical: (tenantId: string, id: string) => string }[] = [
  {
    pattern: /^\/(\w{6})\/m\/([^/]+)\/authenticate$/,
    canonical: (tenantId, id) => `/${tenantId}/messages/${id}/verify-identity`,
  },
  {
    pattern: /^\/(\w{6})\/m\/([^/]+)\/reply$/,
    canonical: (tenantId, id) => `/${tenantId}/messages/${id}/reply`,
  },
  {
    pattern: /^\/(\w{6})\/m\/([^/]+)$/,
    canonical: (tenantId, id) => `/${tenantId}/messages/${id}`,
  },
  {
    pattern: /^\/(\w{6})\/c\/([^/]+)$/,
    canonical: (tenantId, id) => `/${tenantId}/appointment-cancellation/${id}`,
  },
  {
    pattern: /^\/(\w{6})\/q\/([^/]+)$/,
    canonical: (tenantId, id) => `/${tenantId}/questionnaire/${id}`,
  },
  // ENG-21800 Both booking link kinds land on the same route — the store learns
  // which it is from the endpoint, so the path doesn't need to say.
  {
    pattern: /^\/(\w{6})\/booking\/patient\/([^/]+)$/,
    canonical: (tenantId, id) => `/${tenantId}/appointment-booking/${id}`,
  },
  {
    pattern: /^\/(\w{6})\/booking\/public\/([^/]+)$/,
    canonical: (tenantId, id) => `/${tenantId}/appointment-booking/${id}`,
  },
];

/** Path only — the caller carries the query string, so `?authToken=` survives. */
export function toCanonicalPath(path: string): string | null {
  for (const { pattern, canonical } of SHORT_LINK_MAP) {
    const match = path.match(pattern);

    if (match) {
      return canonical(match[1], match[2]);
    }
  }

  return null;
}
